import {
  Box,
  Typography,
  Button,
  Link,
  ThemeProvider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { generateTheme } from 'utils/helpers';

import { useStyles } from './nutritionist-tutorial-panel.styles';

export const NutritionistTutorialPanel = () => {
  const classes = useStyles();

  return (
    <ol>
      {/*<Box mb={1} className={classes.wrapper}>*/}
      {/*  <Typography variant="h6">*/}
      {/*    ¿Cómo me vinculo con un nutriólogo?*/}
      {/*  </Typography>*/}
      {/*  <Button variant="contained" size="small" color="primary">*/}
      {/*    Ver tutorial*/}
      {/*  </Button>*/}
      {/*</Box>*/}
      <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowForwardIosIcon />}
            colo="secondary"
          >
            <Typography variant="h6">
              1.- ¿Cómo me vinculo con un nutriólogo?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <ol className={classes.innerList}>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  EN COMPUTADORA: en la barra de navegación de wellnub.com verás
                  el botón{' '}
                  <Link
                    component={RouterLink}
                    to="/nutritionists"
                    underline="none"
                  >
                    <Typography
                      variant="h6"
                      component="span"
                      className={classes.asLink}
                    >
                      "Buscas nutriólogo"
                    </Typography>
                  </Link>{' '}
                  , haz clic/toca ahí y te dirigiremos al directorio de
                  nutriólogos que Wellnub tiene a tu disposición.
                  <br />
                  EN CELULAR: dirígete a la sección “¿Buscas nutriólogo?” la
                  cual encontrarás en el menú que se despliega al tocar el ícono
                  con 3 rayas horizontales que se encuentra a la derecha en la
                  barra de navegación color gris.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  En esta sección puedes consultar la información, servicios y
                  especialidades de cada nutriólogo y contactar al que más se
                  adecúa a tus necesidades.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Te pediremos llenar un formulario con tu información general y
                  de contacto además de el servicio en el cual estás interesado.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Una vez que completes el formulario, haz clic/toca en el botón
                  “Quiero empezar”. Enviaremos tu solicitud e información al
                  nutriólogo que seleccionaste.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  El nutriólogo deberá aceptar tu solicitud de vinculación para
                  que se vincule contigo, te notificaremos por correo una vez
                  que esto suceda y podrán empezar a trabajar juntos.
                </Typography>
              </li>
            </ol>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>

      {/*<Box mb={1} className={classes.wrapper}>*/}
      {/*  <Typography variant="h6">¿Cómo acepto a un nutriólogo?</Typography>*/}
      {/*  <Button variant="contained" size="small" color="primary">*/}
      {/*    Ver tutorial*/}
      {/*  </Button>*/}
      {/*</Box>*/}
      <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowForwardIosIcon />}
            colo="secondary"
          >
            <Typography variant="h6">
              2.- ¿Cómo acepto a un nutriólogo?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <ol className={classes.innerList}>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Cuando un nutriólogo te mande una solicitud para vincularse
                  contigo, te enviaremos un correo electrónico para notificarte.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  En la sección “Próximos Eventos” en la “Página Principal” de
                  tu perfil Wellnub verás la solicitud del nutriólogo que desea
                  vincularse contigo.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Haz click/toca en “Aceptar” para aprobar la solicitud.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Al aceptarlo, podrás empezar a trabajar con tu nutriólogo a
                  través de Wellnub y te podrá asignar pases Wellnub- InBody®,
                  enviar planes alimenticios, consultar tu historia clínica, tus
                  resultados y seguir de cerca tu progreso.
                </Typography>
              </li>
            </ol>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>

      {/*<Box mb={1} className={classes.wrapper}>*/}
      {/*  <Typography variant="h6">*/}
      {/*    Si actualmente tengo un nutriólogo y deseo empezar a trabajar con*/}
      {/*    uno nuevo, ¿me puedo vincular con otro nutriólogo Wellnub?*/}
      {/*  </Typography>*/}
      {/*  <Button variant="contained" size="small" color="primary">*/}
      {/*    Ver tutorial*/}
      {/*  </Button>*/}
      {/*</Box>*/}
      <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowForwardIosIcon />}
            colo="secondary"
          >
            <Typography variant="h6">
              3.- Si actualmente tengo un nutriólogo y deseo empezar a trabajar
              con uno nuevo, ¿me puedo vincular con otro nutriólogo Wellnub?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <Typography variant="body2">
              Sí es posible. Solo busca al nuevo nutriólogo con quien deseas
              vincularte (dentro del directorio de nutriólogos Wellnub, en la
              sección{' '}
              <Link component={RouterLink} to="/nutritionists" underline="none">
                <Typography
                  variant="h6"
                  component="span"
                  className={classes.asLink}
                >
                  "¿Buscas nutriólogo?"
                </Typography>
              </Link>{' '}
              , envíale la solicitud de vinculación y una vez que el nutriólogo
              te acepte, quedarás vinculado a este nuevo nutriólogo. (Ver
              tutorial ¿Cómo me vinculo con un nutriólogo?)
              <br />
              <Typography variant="h6" component="span">
                NOTA
              </Typography>
              : Al vincularte con un nuevo nutriólogo, en automático se
              cancelará la vinculación que tenías con el nutriólogo anterior, ya
              que sólo puedes ser paciente activo de un nutriólogo a la vez.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>

      {/*<Box mb={1} className={classes.wrapper}>*/}
      {/*  <Typography variant="h6">*/}
      {/*    ¿Cómo puedo ver el plan de alimentación que me ha asignado mi*/}
      {/*    nutriólogo?*/}
      {/*  </Typography>*/}
      {/*  <Button variant="contained" size="small" color="primary">*/}
      {/*    Ver tutorial*/}
      {/*  </Button>*/}
      {/*</Box>*/}
      <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowForwardIosIcon />}
            colo="secondary"
          >
            <Typography variant="h6">
              4.- ¿Cómo puedo ver el plan de alimentación que me ha asignado mi
              nutriólogo?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <Typography variant="body2">
              Dentro de tu perfil Wellnub, en tu “Página Principal”, encontrarás
              la sección “Mis programas” (en la parte inferior). <br />
              En esta sección verás la card de tu nutriólogo con su nombre,
              fotografía e información de contacto. En esta misma card,
              encontrarás el botón “Mi plan nutricional”. Simplemente haz
              clic/toca para poder ver el plan más reciente que tu nutriólogo te
              asignó. Podrás consultarlo en cualquier momento desde tu
              computadora o tu celular.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>
    </ol>
  );
};
